document.addEventListener("DOMContentLoaded", function () {

    const bottomATC = document.querySelector('.bottom-atc');
    const addToCartBtn = document.querySelector('.addToCartBtn');

    if (!bottomATC || !addToCartBtn) return;

    let isATCVisible = true;
    let lastScrollY = window.scrollY;
    let isScrollingUp = false;

    // Track ATC visibility only
    const observer = new IntersectionObserver((entries) => {
        isATCVisible = entries[0].isIntersecting;
    }, {
        threshold: 0
    });

    observer.observe(addToCartBtn);

    // Scroll logic decides visibility
    window.addEventListener('scroll', () => {
        const currentScrollY = window.scrollY;
        isScrollingUp = currentScrollY < lastScrollY;
        lastScrollY = currentScrollY;

        const atcRect = addToCartBtn.getBoundingClientRect();
        const hasScrolledPastATC = atcRect.bottom < 0;

        // SHOW only when ALL conditions are met
        if (
            !isATCVisible &&
            hasScrolledPastATC &&
            isScrollingUp
        ) {
            bottomATC.classList.add('show');
            bottomATC.classList.remove('hide');
        } else {
            bottomATC.classList.add('hide');
            bottomATC.classList.remove('show');
        }
    });

    // Bundle button support
    setTimeout(() => {
        const bundlesButton = document.querySelector('.bogos-bundles-quantity-break-button-add');
        if (bundlesButton) {
            observer.observe(bundlesButton);
        }
    }, 1400);

    // Smooth scroll delegation
    const contentContainer = document.querySelector('.batc_content');

    if (contentContainer) {
        contentContainer.addEventListener('click', (event) => {
            const link = event.target.closest('a[href^="#"]');
            if (!link) return;

            const target = document.querySelector(link.getAttribute('href'));
            if (!target) return;

            event.preventDefault();
            target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
    }

});
